import { useState } from "react";
import axios from "axios";

const Book = () => {
  const [formData, setFormData] = useState({
    typeOfService: "",
    preferredMeetingDate: "",
    preferredMeetingLocation: "",
    phoneNumber: "",
    email: "",
    fullName: "",
    details: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure all fields are filled
    for (const key in formData) {
      if (!formData[key]) {
        setMessage("All fields are required.");
        return;
      }
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post("https://backend.lawberonlegals.com/api/book", formData);
      alert("Booking request submitted successfully");
      setMessage(response.data.message);
      setFormData({
        typeOfService: "",
        preferredMeetingDate: "",
        preferredMeetingLocation: "",
        phoneNumber: "",
        email: "",
        fullName: "",
        details: "",
      });
    } catch (error) {
      setMessage("Failed to submit booking request. Try again.");
    }

    setLoading(false);
  };

  return (
    <section>
      <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-lg p-8 mt-10">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">Book a Consultation</h2>
        {message && <p className="text-center text-red-500 mb-4">{message}</p>}
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-gray-700 font-medium">Type of Service</label>
            <select
              name="typeOfService"
              value={formData.typeOfService}
              onChange={handleChange}
              className="w-full mt-1 p-3 border rounded-lg"
            >
              <option value="">Select Service</option>
              <option value="REGULATORY COMPLIANCE">REGULATORY COMPLIANCE</option>
              <option value="REAL ESTATE ADVISORY">REAL ESTATE ADVISORY</option>
              <option value="IMMIGRATION CONSULTANCY">IMMIGRATION CONSULTANCY</option>
              <option value="DEBT RECOVERY">DEBT RECOVERY</option>
              <option value="LITIGATION AND ARBITRATION">LITIGATION AND ARBITRATION</option>
              <option value="CORPORATE TRAINING">CORPORATE TRAINING</option>
            </select>
          </div>
          <div>
            <label className="block text-gray-700 font-medium">Preferred Meeting Date</label>
            <input
              type="date"
              name="preferredMeetingDate"
              value={formData.preferredMeetingDate}
              onChange={handleChange}
              className="w-full mt-1 p-3 border rounded-lg"
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium">Preferred Meeting Location</label>
            <input
              type="text"
              name="preferredMeetingLocation"
              value={formData.preferredMeetingLocation}
              onChange={handleChange}
              placeholder="e.g. LawBeron Office, Online Call"
              className="w-full mt-1 p-3 border rounded-lg"
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium">Phone Number</label>
            <input
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              placeholder="+234 812 345 6789"
              className="w-full mt-1 p-3 border rounded-lg"
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="you@example.com"
              className="w-full mt-1 p-3 border rounded-lg"
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium">Full Name</label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="John Doe"
              className="w-full mt-1 p-3 border rounded-lg"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-gray-700 font-medium">Details</label>
            <textarea
              name="details"
              value={formData.details}
              onChange={handleChange}
              placeholder="Provide additional details about your case..."
              className="w-full mt-1 p-3 border rounded-lg h-32"
            ></textarea>
          </div>
          <div className="md:col-span-2">
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Book Consultation"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Book;
